import { useEffect } from "react";
import { useRouter } from "next/router";
import { useUserState } from "@/states/user.state";
import { VisitorType } from "@/types/all.types";
import { getVisitorLog } from "@/helper/getVisitorLog";
import { commonRequest } from "@/services/common.request";
import { SectionsStoreTypes } from "@/types/user.types";
import { DEBUGGER } from "@/helper/helper";

export default function useGuestLog() {
  useRouter();
  const userState = useUserState.getState();

  useEffect(() => {
    (async function () {
      await initVisitor();
    })();
  }, []);

  // 477 status code if payload is empty for visitor log
  async function initVisitor() {
    try {
      const visitorData = getVisitorLog({
        queryParams: userState.queryParams,
        version: userState.version,
        visitorToken: userState.guestToken || null,
      });

      let reSendStore = false;
      const params = Object.fromEntries(new URLSearchParams(window.location.search));
      if (userState.guestToken !== visitorData.currentVisitorToken) {
        reSendStore = true;
      } else {
        const savedParams = userState ? JSON.parse(userState.queryParams as string) : null;

        const referrer = document.referrer;
        const isExternalReferral =
          referrer && !referrer.includes(process.env.NEXT_PUBLIC_SITE_HOST!);
        if (
          params?.gclid &&
          (params?.gclid !== savedParams?.gclid ||
            params?.keyword !== savedParams?.keyword ||
            params?.utm_source !== savedParams?.utm_source ||
            isExternalReferral)
        ) {
          reSendStore = true;
        }
      }
      if (reSendStore) {
        await commonRequest.visitorInitialize(visitorData?.collectedData as VisitorType);
        userState.setQueryParams(JSON.stringify(visitorData?.collectedData));
        userState.setGuestToken(visitorData?.currentVisitorToken);
      }
    } catch (err) {
      DEBUGGER("error Query Params data => ", err);
    }
  }

  return userState.guestToken;
}
export async function generateGuest(userState: SectionsStoreTypes) {
  const visitorData = getVisitorLog({
    queryParams: userState.queryParams,
    version: userState.version,
    visitorToken: userState.guestToken,
  });

  if (userState.guestToken !== visitorData.currentVisitorToken) {
    await commonRequest.visitorInitialize(visitorData?.collectedData!);
    userState.setQueryParams(JSON.stringify(visitorData?.collectedData));
    userState.setGuestToken(visitorData?.currentVisitorToken);
  }
}
